/**
 * Aruban florin.
 */
export var AWG = {
  code: 'AWG',
  base: 10,
  exponent: 2
};